import React from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import { useModal } from './Modal/ModalContext';
import { useTimeModal } from './TimeModal/TimeModalContext';

import Loading from './Loading';

const WorkerCase = ({ caseId, workerId, onAppointWorkerForCaseSuccess }) => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    const [userRole, setUserRole] = React.useState('');
    
    React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
        const decodedToken = jwtDecode(token);
        setUserRole(decodedToken.role);
    }
    }, []);

    const [userId, setUserId] = React.useState(null);
    const [worker, setWorker] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get(`/api/user`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setUserId(response.data.id);
        })
        .catch(error => {
            openTimeModal(`Ошибка загрузки компонента: ${error.response?.data.message || error.message}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        })
    }, [caseId, loading])

    React.useEffect(() => {
        if (!workerId) return;
        const token = localStorage.getItem('token');
        axios.get(`/api/get-o-user?id=${workerId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setWorker(response.data);
        })
        .catch(error => {
            openTimeModal(`Ошибка загрузки компонента: ${error.response?.data.message || error.message}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        })
    }, [workerId])

    const workerAppointment = () => {
        const token = localStorage.getItem('token');
        axios.put(`/api/appoint-a-worker-on-a-case?userId=${userId}&caseId=${caseId}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            if (response.data == '') {
                openTimeModal('Вы успешно назначены', 'success');
            } else {
                if (response.data == userId) {
                    openTimeModal('Вы успешно откреплены', 'success');
                } else {
                    openTimeModal('Работник успешно откреплён', 'success');
                }
            }
            if (onAppointWorkerForCaseSuccess) {onAppointWorkerForCaseSuccess()};
        })
        .catch(error => {
            openTimeModal(`Ошибка: ${error.response?.data.message || error.message}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        })
    }

    return (
        <>
            {loading ? (
                <Loading />
            ) 
            : 
            (workerId===null ? 
                (
                    <>
                        <a>На данный момент не закреплено</a>
                        {userRole!=='Администратор' && userRole!=='Менеджер' ? 
                            (
                                <button type='button' className='button black' onClick={() => {workerAppointment()}}>Начать ведение</button>
                            ) 
                            : 
                            (
                                <button type='button' className='button gray' onClick={() => {openModal('Сообщение', 'Данная функция недоступна учётным записям с ролью "Администратор" или "Менеджер".')}}>Начать ведение</button>
                            )
                        }
                    </>
                ) 
                : 
                (
                    <>
                        <a>{worker.lastname} {worker.firstname} {worker.surname}</a>
                        <a style={{textDecoration: 'underline black', width: 'fit-content'}} href={`mailto:${worker.email}`}>{worker.email}</a>
                        {userRole=='Администратор' || userRole=='Менеджер' || userId==workerId ? 
                        (
                            <button type='button' className='button black' onClick={() => {workerAppointment()}}>Прекратить ведение</button>
                        )
                        :
                        (<></>)
                        }
                    </>
                )
            )
            }
        </>
    )
}

export default WorkerCase;